import { useGetProspectoByIdProspecto } from "@/shared/actions/erp";
import { Navigate, useParams } from "react-router-dom";
import { LoaderComponent } from "@/shared/components/ui";
import SavePreventa from "../../shared/component/SavePreventa/SavePreventa";
import { EstadoProspectoEnum, ROUTER_PATHS } from "@/shared";
import { toast } from "react-toastify";

export default function PreventaCreatePage() {

  const { idprospecto } = useParams();

  const { data, isLoading, isPending } = useGetProspectoByIdProspecto(idprospecto!);

  if (isPending || isLoading) return <LoaderComponent />

  if (!data) return null;


  if (data.estado_prospecto == EstadoProspectoEnum.EN_PROCESO) {
    toast.info('El prospecto esta EN PROCESO de venta.');
    return <Navigate to={ROUTER_PATHS.ventas.prospectoNav} />
  }

  return (
    <SavePreventa dataProspecto={data} />
  );

}